module.exports = __webpack_public_path__ + "static/media/jumbo.1cb13a13.jpg";